const initialState = {
  treeData: [],
  loading: false,
  error: null,
  rawObjectives: [],
  associatedTeams: [],
  rootTeam: null,
  initialDataFetched: false,
};

export default initialState;
